import React from "react";
import { CgSpinnerTwo } from "react-icons/cg";

interface IButtonProps {
  label?: String;
  className?: String;
  type?: `PRIMARY` | `FLAT` | `OUTLINED`;
  icon?: JSX.Element;
  color?: string;
  loading?: boolean;
  onClick?: () => void;
}
function Button({ label, type = `PRIMARY`, icon: Icon, className, onClick, loading = false, color = "primary" }: IButtonProps) {
  return (
    <div onClick={!loading && onClick} className={`${type === `PRIMARY` ? `bg-${color} hover:bg-dark text-white ` : type === `FLAT` ? ` text-${color}  hover:bg-gray-100` : ` text-${color} hover:text-dark hover:border-dark border border-${color}`} py-2 px-3 rounded font-semibold cursor-pointer animate  flex items-center justify-center group select-none ${className}`}>
      {loading ? <CgSpinnerTwo className={`animate-spin mr-4`} /> : Icon && <div className={label && `mr-4`}>{Icon}</div>}
      {label && <p className={`${type === `PRIMARY` ? `text-white ` : `text-${color}  animate`}`}>{label}</p>}
    </div>
  );
}

export default Button;
